export default __webpack_public_path__ + "static/media/icon-dine-table.d9398881.svg";